import React from 'react';
import { render } from 'react-dom';
import './index.css';
import App from './App';

render(<App />, document.getElementById('root'));

// Register service worker for caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Service worker registration failed silently
    });
  });
}
